const storage = localStorage; // eslint-disable-line no-undef

/**
 * setStorage
 *
 * Set the local storage flag
 *
 * @param {string} key
 * @param {string} value
 */
export function setStorage( key, value = 1 ) {
	storage.setItem( key, value );
}

/**
 * getStorage
 *
 * Returns the item from appropriate storage.
 *
 * @param {string} key
 */
export function getStorage( key ) {
	return storage.getItem( key );
}

/**
 * clearStorage
 *
 * Clears the local storage key if it exists.
 *
 * @param {string} key
 */
export function clearStorage( key ) {
	storage.removeItem( key );
}

/**
 * Check if local storage is available.
 *
 * @return {boolean} whether or not
 */
export function localStorageExists() {
	const als = 'angryls';

	try {
		storage.setItem( als, als );
		storage.removeItem( als );
		return true;
	} catch ( e ) {
		return false;
	}
}

/**
 * setCookie
 *
 * Sets a cookie. Basic function from W3 schools.
 *
 * @param {string} cname
 * @param {string} cvalue
 * @param {string} exdays
 */
export function setCookie( cname, cvalue, exdays ) {
	const d = new Date();
	d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
	const expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/**
 * getCookie
 *
 * Gets a cookie. Basic function from W3 schools.
 *
 * @param {string} cname
 */
export function getCookie( cname ) {
	const name = cname + '=';
	const ca = document.cookie.split( ';' );
	for ( let i = 0; i < ca.length; i++ ) {
		let c = ca[ i ];
		while ( c.charAt( 0 ) === ' ' ) {
			c = c.substring( 1 );
		}
		if ( c.indexOf( name ) === 0 ) {
			return c.substring( name.length, c.length );
		}
	}
	return '';
}
